export const FEEDBACK_SUBJECT_KEYS = [
  'general',
  'technical_support',
  'purchase_billing',
  'feature_request',
  'report_bug',
  'account_deletion',
];

export const DEFAULT_FEEDBACK_SUBJECT = 'general';
